import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Loader from '../Loader/Loader';
import { forgotPasswordConfirm, forgotPasswordRequest } from '../../APIClient/auth.js';

const ForgotPassword = props => {
  const { loginUser, backToLogin } = props;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const handleResetRequest = async event => {
    event.preventDefault();
    if (isLoading) return;

    setIsLoading(true);
    setIsCodeSent(false);
    try {
      await forgotPasswordRequest(email);
      window.ALERT.success('If an account with this email exists, a password reset code has been sent to your email address.', { hideAfter: 10 });
      setIsCodeSent(true);
    } catch (error) {
      window.ALERT.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdatePassword = async event => {
    event.preventDefault();
    if (isLoading) return;

    setIsLoading(true);

    try {
      await forgotPasswordConfirm({
        email,
        newPassword: password,
        code: verificationCode
      });

      await loginUser({ email, password });
    } catch (error) {
      window.ALERT.error(error || 'There was an issue resetting your password, please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className='auth-section'>
      {isCodeSent ? (
        <div>
          <div className='auth-header'>An email should be delivered shortly.</div>
          <div className='auth-subheader'>If you do not receive an email please reach out to team@shopmy.us for assistance.</div>
          <form onSubmit={handleUpdatePassword}>
            <input
              placeholder='Verification Code'
              className='standard-input'
              onChange={({ target }) => setVerificationCode(target.value)}
              value={verificationCode}
            />
            <input type='email' className='standard-input' placeholder='Email' onChange={() => {}} value={email} disabled />
            <input
              type='password'
              className='standard-input'
              placeholder='New Password'
              onChange={({ target }) => setPassword(target.value)}
              value={password}
            />

            <div className='login-btn-container'>
              <input type='submit' className={classnames('login-btn', { loading: isLoading })} value='SET NEW PASSWORD' />
              {isLoading && <Loader size={70} />}
            </div>
          </form>
        </div>
      ) : (
        <div>
          <div className='auth-header'>Enter email to reset password</div>
          <form onSubmit={handleResetRequest}>
            <input
              type='email'
              className='standard-input'
              placeholder='Email'
              onChange={({ target }) => setEmail(target.value)}
              value={email}
              disabled={isLoading}
            />
            <div className='login-btn-container'>
              <input type='submit' className={classnames('login-btn', { loading: isLoading })} value='REQUEST PASSWORD RESET' />
              {isLoading && <Loader size={70} />}
            </div>
            {!!backToLogin && (
              <div onClick={backToLogin} className='back-to-login'>
                Back to Login
              </div>
            )}
          </form>
        </div>
      )}
    </div>
  );
};

ForgotPassword.propTypes = {
  loginUser: PropTypes.func.isRequired,
  backToLogin: PropTypes.func
};

export default ForgotPassword;
